import React, { ReactElement } from 'react';
import moment from "moment";
import { IMovie } from "@common/redux/types/movie";
import styles from './MovieHeaderDescription.module.scss';

interface IProps {
  movie: IMovie;
}

export const MovieHeaderDescription = ({ movie }: IProps): ReactElement => {
  const {
    genres = [],
    creationYear,
    countries = [],
    releaseDate,
  } = movie;

  return (
    <div className={styles.container}>
      {genres.length > 0 && (
        <div className={styles.row}>
          <div className={styles.label}>Жанр</div>
          <div className={styles.text}>{genres.map((g) => g.name).join(', ')}</div>
        </div>
      )}
      {creationYear && (
        <div className={styles.row}>
          <div className={styles.label}>Год</div>
          <div className={styles.text}>{creationYear}</div>
        </div>
      )}
      {countries.length > 0 && (
        <div className={styles.row}>
          <div className={styles.label}>Страна</div>
          <div className={styles.text}>{countries.join(', ')}</div>
        </div>
      )}
      {releaseDate && (
        <div className={styles.row}>
          <div className={styles.label}>В кино</div>
          <div className={styles.text}>{moment(releaseDate).format('с D MMMM YYYY')}</div>
        </div>
      )}
    </div>
  )
}
